/**
 * The fill behind a person's initials, picked from their name so they keep
 * their colour on every screen and every platform (DESIGN.md, "Avatars").
 * Never sun orange, which would read as unread, and never the error brick.
 */

/** In DESIGN.md's order; the index is what iOS and Android must match. */
export const AVATAR_COLOR_CLASSES = [
  'bg-primary text-primary-foreground', // 5.93:1
  'bg-wood text-wood-foreground', // 6.26:1
  'bg-umber text-umber-foreground', // 6.46:1
  'bg-muted-foreground text-primary-foreground', // 7.14:1
] as const;

/** 32-bit FNV-1a over the name's UTF-8 bytes, modulo the palette size. */
export function avatarColorIndex(name: string): number {
  let hash = 0x811c9dc5;
  for (const byte of new TextEncoder().encode(name)) {
    hash ^= byte;
    hash = Math.imul(hash, 0x01000193);
  }
  return (hash >>> 0) % AVATAR_COLOR_CLASSES.length;
}

export function avatarColorClasses(name: string): string {
  return AVATAR_COLOR_CLASSES[avatarColorIndex(name)];
}
